import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e8bf94f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "系统API接口，绑定了具体的权限表示需要具有相应的权限才能访问，未绑定任何权限则表示都可以访问")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "用于管理系统的API接口", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_bind_permission = _resolveComponent("bind-permission");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.uac.requestPath.list,
    columns: $data.columns,
    rowKey: "key",
    showPagination: false,
    showRowIndex: false,
    selectionEnable: false,
    linkButtons: $data.linkButtons,
    searchItems: $data.searchItems
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["fetchApi", "columns", "linkButtons", "searchItems"]), _createVNode(_component_el_dialog, {
    modelValue: $data.bindPermissionDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.bindPermissionDialog = $event),
    title: "绑定权限",
    "destroy-on-close": "",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [_createVNode(_component_bind_permission, {
      requestPath: $data.currentRequestPath,
      onOnClose: _cache[0] || (_cache[0] = $event => $data.bindPermissionDialog = false),
      onOnSubmit: $options.doBindPermission
    }, null, 8, ["requestPath", "onOnSubmit"])]),
    _: 1
  }, 8, ["modelValue"])]);
}